export enum ViewingGroupStatus {
  Active = "Active",
  Archived = "Archived",
}
